import { createHash } from 'crypto';

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

export const GTM_ID = 'GTM-WPGQVRKV';

export const pageView = (url: string) => {
  if (typeof window.dataLayer !== 'undefined') {
    sendEvent('pageview', 'page_view', { page: url });
  }
};

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const sendEvent = (name: string, type: string, params?: Record<string, any>) => {
  const sha256email = createHash('sha256')
    .update(localStorage.getItem('USER_EMAIL') ?? '')
    .digest('hex');
  const franchiseeId = localStorage.getItem('SELECTED_FRANCHISEE');
  if (process.env.NEXT_PUBLIC_BACKOFFICE_ENV === 'production') {
    window.dataLayer.push({
      event: name,
      event_parameters: {
        type,
        ...params,
      },
      user_parameters: {
        sha256email,
        franchiseeId,
      },
    });
  }
};
